module.exports = __webpack_public_path__ + "static/media/logo.561312df.png";